import Details from './Details';
import { useTranslation } from 'react-i18next';
import { Contributor, ProductMeta } from '@almamedia-legal-insights/types';
import { useMemo } from 'react';
import NavigationMenuDialog from '../NavigationMenu/Dialog';

export default function Dialog({
  open,
  onClose,
  productMeta,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  productMeta: ProductMeta | null;
}>) {
  const { t } = useTranslation();

  const authors = useMemo(() => {
    if (!productMeta || !Array.isArray(productMeta.contributors)) {
      return [];
    }

    return productMeta.contributors
      .filter((c: Contributor) => c.role === 'Author')
      .map((c: Contributor) => c.name);
  }, [productMeta]);

  if (!productMeta) {
    return null;
  }

  return (
    <NavigationMenuDialog
      open={open}
      onClose={onClose}
      title={t('readingView.aboutBook.title')}
      closeLabel={t('readingView.aboutBook.close')}
    >
      <Details
        isbn={productMeta.isbn}
        title={productMeta.title}
        authors={authors}
        publicationYear={productMeta.publicationYear}
        summary={productMeta.descriptionHtml}
        coverImageUrl={productMeta.coverImageUrl}
      />
    </NavigationMenuDialog>
  );
}
